import api from "./api";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadOfferSummary(documentId, siteId) {
  return async (dispatch, getState) => {
    let { offerSummary } = getState().currentOffer.offerSidebarData;
    if (offerSummary.documentId === documentId && offerSummary.siteId === siteId) return;

    try {
      offerSummary = await dispatch(sendHttpRequest(api.getOfferSummary(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_OFFER_SUMMARY_SUCCEEDED, payload: { offerSummary } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      dispatch({ type: actionTypes.LOAD_OFFER_SUMMARY_FAILED, payload: { error } });
    }
  };
}

export function loadOfferKpi(documentId, siteId, taskIsChanged = false) {
  return async (dispatch, getState) => {
    let { offerKpi } = getState().currentOffer.offerSidebarData;
    if (offerKpi.documentId && offerKpi.documentId === documentId) {
      if (!taskIsChanged) return;
    }

    try {
      offerKpi = await dispatch(sendHttpRequest(api.getOfferKpi(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_OFFER_KPI_SUCCEEDED, payload: { offerKpi } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      dispatch({ type: actionTypes.LOAD_OFFER_KPI_FAILED, payload: { error } });
    }
  };
}
